import React from "react";
import Map from "../../components/GoogleMap/GoogleMap";
import {useSelector} from "react-redux";
import {getSelectedLocations} from "../../redux/Selectors/sites.selectors";
import {isEmpty} from "lodash";

function Locations() {
  const selectedLocation = useSelector(getSelectedLocations);
  const {selectedAddress = {}} = selectedLocation;

  return (
    <div>
      <div style={{height: "285px"}}>
        <Map address={!isEmpty(selectedAddress) ? selectedAddress["label"] : ""} />
      </div>
    </div>
  );
}

Locations.propTypes = {};

export default Locations;
